import React, { useState } from "react";
import styled from "@emotion/styled";
import moment from "moment";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import UpdateProductOfferModal from "../../../components/modals/Customer/updateProductOfferReqModal";
import ChangeSaved from "../../../components/popups/ChangeSaved";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  customerProductOfferRequestApproveReject,
  productOfferRequestUpdateList,
} from "../../../redux/actions/customerActions";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    maxWidth: "45rem",
    height: "25rem",
    overflowY: "scroll",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const OffersDetailTable = ({
  maxWidth = "80rem",
  tableData = [],
  divisionName,
  stateName,
  districtName,
}) => {
  const params = useParams();
  const dispatch = useDispatch();
  const [updateOfeerShow, setUpdateOfeerShow] = useState(false);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");

  const approvFunc = (request_id) => {
    dispatch(
      customerProductOfferRequestApproveReject(
        { status: "approved", doctor_id: params?.id, request_id: request_id },
        onApproveSuccess,
        onApproveError
      )
    );
  };

  const rejctFunc = (request_id) => {
    dispatch(
      customerProductOfferRequestApproveReject(
        { status: "rejected", doctor_id: params?.id, request_id: request_id },
        onApproveSuccess,
        onApproveError
      )
    );
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onApproveSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
    dispatch(
      productOfferRequestUpdateList({
        changedOffer: data.data.data.productOffer,
      })
    );
  };

  const onApproveError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  return (
    <div className="">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table text-nowrap">
          <tr className="table-rows">
            <th className="order-table-heads color_262c3d" width={"10%"}>
              Product Id
            </th>
            <th className="order-table-heads color_262c3d" width={"10%"}>
              Product Name
            </th>
            <th className="order-table-heads color_262c3d" width={"10%"}>
              Offer
            </th>
            <th className="order-table-heads color_262c3d" width={"10%"}>
              Request Date
            </th>
            <th className="order-table-heads color_262c3d" width={"8%"}></th>
          </tr>
          <tbody style={{ position: "relative" }}>
            {tableData.length > 0 ? (
              tableData.map((ele, index) => (
                <tr className="table-rows1" key={index}>
                  <td className="order-table-each-row-data">
                    {ele?.product?.product_id}
                  </td>
                  <td className="order-table-each-row-data">
                    {ele?.product?.product_name}
                  </td>
                  <td className="order-table-each-row-data">
                    {ele?.offer?.offer_type == "quantity"
                      ? `${ele?.offer?.offer}+${ele?.offer?.offer_qty}`
                      : "--"}
                  </td>
                  <td className="order-table-each-row-data">
                    {ele?.offer?.updatedAt
                      ? ` ${moment(ele?.offer?.updatedAt).format(
                          "DD MMM YYYY, HH:mm A"
                        )}`
                      : "--"}
                  </td>

                  <>
                    <td className="order-table-each-row-data cursor_pointer d-flex gap-3">
                      {ele.status === "pending" ? (
                        <>
                          <AdminButton
                            background="#7065E4"
                            color="white"
                            width="100px"
                            onClick={() => approvFunc(ele.id)}
                          >
                            Approve
                          </AdminButton>
                          <AdminButton
                            background="#FF6F5B"
                            color="white"
                            width="100px"
                            onClick={() => rejctFunc(ele.id)}
                          >
                            Reject
                          </AdminButton>
                          <AdminButton
                            background="#FFC107"
                            color="white"
                            width="100px"
                            onClick={() => {
                              setUpdateOfeerShow(true);
                              setSelectedProduct(ele);
                            }}
                          >
                            Modefy
                          </AdminButton>
                        </>
                      ) : ele.status === "approved" ? (
                        <AdminButton
                          background="#24D626"
                          color="white"
                          width="100px"
                        >
                          Approved
                        </AdminButton>
                      ) : ele.status === "rejected" ? (
                        <AdminButton
                          background="#B0B3C7"
                          color="white"
                          width="100px"
                        >
                          Rejected
                        </AdminButton>
                      ) : (
                        ""
                      )}
                    </td>
                  </>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="1" className="text-center no-data-container fs_16">
                  <span>~ No Data Found ~</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableContainer>
      <UpdateProductOfferModal
        stateName={stateName}
        districtName={districtName}
        divisionName={divisionName}
        productDetails={selectedProduct}
        show={updateOfeerShow}
        ShowClose={() => setUpdateOfeerShow(false)}
      />
      <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </div>
  );
};

export default OffersDetailTable;
